import { render, staticRenderFns } from "./_pre-orders.modal.vue?vue&type=template&id=237303f2&scoped=true"
import script from "./_pre-orders.modal.vue?vue&type=script&lang=js"
export * from "./_pre-orders.modal.vue?vue&type=script&lang=js"
import style0 from "./_pre-orders.modal.vue?vue&type=style&index=0&id=237303f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237303f2",
  null
  
)

export default component.exports